import { Component, OnInit } from '@angular/core';
import { TrainerService } from '../../../../@shared/services/trainer.service';
import { TrainerRecommendationResponse } from '../../../../@shared/models/response.module';
import { ToastService } from '../../../../@core/services/toast.service';

@Component({
  selector: 'app-admin-recommendations',
  standalone: false,
  templateUrl: './admin-recommendations.html',
  styleUrl: './admin-recommendations.css'
})
export class AdminRecommendations implements OnInit {
  loading: boolean = true;
  recommendations: TrainerRecommendationResponse[] = [];

  // Pagination
  currentPage: number = 1;
  perPage: number = 20;
  totalItems: number = 0;
  totalPages: number = 0;
  Math = Math;

  // Filters
  statusFilter: string = '';

  actionLoading: boolean = false;

  constructor(
    private trainerService: TrainerService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.loadRecommendations();
  }

  loadRecommendations() {
    this.loading = true;
    const params: { page?: number; per_page?: number; status?: string } = {
      page: this.currentPage,
      per_page: this.perPage
    };
    if (this.statusFilter) {
      params.status = this.statusFilter;
    }

    this.trainerService.getRecommendations(params).subscribe({
      next: (response: any) => {
        if (Array.isArray(response)) {
          this.recommendations = response;
          this.totalItems = response.length;
          this.totalPages = 1;
        } else {
          this.recommendations = response.data || response;
          this.totalItems = response.total_items || this.recommendations.length;
          this.totalPages = response.total_pages || 1;
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onFilterChange() {
    this.currentPage = 1;
    this.loadRecommendations();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.loadRecommendations();
  }

  markReviewed(rec: TrainerRecommendationResponse) {
    this.actionLoading = true;
    this.trainerService.markRecommendationReviewed(rec.recommendation_id as any).subscribe({
      next: () => {
        this.toastService.success('Recommendation marked as reviewed');
        this.actionLoading = false;
        this.loadRecommendations();
      },
      error: () => {
        this.toastService.error('Failed to update recommendation');
        this.actionLoading = false;
      }
    });
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'pending': return 'bg-warning-subtle text-warning';
      case 'reviewed': return 'bg-success-subtle text-success';
      default: return 'bg-secondary-subtle text-secondary';
    }
  }

  getPages(): number[] {
    const pages: number[] = [];
    const maxPages = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
    let end = Math.min(this.totalPages, start + maxPages - 1);
    if (end - start + 1 < maxPages) {
      start = Math.max(1, end - maxPages + 1);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }
}
